import { useCallback } from "react";
import { Node } from "@xyflow/react";
import { useAtomValue } from "jotai";
import { nodesAtom } from "@zapier/canvas-state";

import styles from "./ContextMenu.module.css";

type Props = {
  id: string;
  top: number | undefined;
  left: number | undefined;
  onClose: () => void;
  onNodeDelete: (node: Node) => void;
};

export function ContextMenu({
  id,
  top,
  left,
  onClose,
  onNodeDelete,
  ...props
}: Props) {
  const nodes = useAtomValue(nodesAtom);

  const handleDeleteNode = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      const deletedNode = nodes.find((node) => node.id === id);
      onClose();

      if (!deletedNode) {
        return;
      }

      onNodeDelete(deletedNode);
    },
    [id, nodes, onClose, onNodeDelete],
  );

  return (
    <div className={styles.menu} style={{ top, left }} {...props}>
      <button onClick={handleDeleteNode}>Delete</button>
    </div>
  );
}
